module.exports = __webpack_public_path__ + "static/media/about-tender.9d2ded1b.png";